<form [formGroup]="formAviso" (ngSubmit)="submit()">
    <div class="row">
        <div class="col">
            <label class="w-100">{{ 'AVISO.LIST.COLUMN.TITLE' | translate }}</label>
            <input class="w-100"type="text" name="titulo" formControlName="titulo">
        </div>
    </div>
    <div class="row mt-3">
        <div class="col">
            <label class="w-100">{{ 'AVISO.LIST.COLUMN.DESCRIPTION' | translate }}</label>
            <textarea rows="4" cols="90" name="cuerpo" formControlName="cuerpo"></textarea>
        </div>
    </div>
    
    <input type="file" class="mt-3 upload" name="file" accept="application/pdf" (change)="onFileChange($event)">
    
    <div class="w-100">
        <mat-checkbox formControlName="visible" class="mt-2">{{ 'PROCEDIMIENTO.EDIT.ACTIVE' | translate }}</mat-checkbox>
    </div>

    <div *ngIf = "adviseError || typeError || uploadSucesfully" class="w-100 d-flex justify-content-center">
        <div *ngIf = "adviseError" class="danger alert-danger adviseError">
            <p class="mt-2">{{ 'AVISO.ERROR.REQUIRED' | translate }}</p>
        </div>

        <div *ngIf = "typeError" class="danger alert-danger typeError">
            <p class="mt-2">{{ 'AVISO.ERROR.PDF_ONLY' | translate }}</p>
        </div>

        <div *ngIf = "uploadSucesfully" class="alert alert-success uploadSucesfully">
            <p>{{ 'AVISO.SUCCESS.PUBLISHED' | translate }}</p>
        </div>
    </div>

    <div class="w-100 mt-3 d-flex justify-content-center">
        <button type="submit" class="btn btn-primary m-left">{{ 'COMMON.BUTTON.SAVE' | translate }}</button>
    </div>
    
</form>
